import React, { Component } from 'react';
import NavBar from './NavBar.js';
import Footer from './Footer.js';
import Cookies from 'js-cookie';
import Swal from 'sweetalert2';
import CertificadoDisplay from './CertificadoDisplay.js';
import { properties } from './properties.js';
import { withTranslation } from 'react-i18next';
import i18n from './I18N/I18n.js'; 
import { loadWeb3, logout, apiSecuredRequest, isUserOrWallet, setBearer, cargarIdiomaPreferido} from './functions.js';
import './css/listaEmpresas.css'
class ListaCertificados extends Component {

    async componentDidMount() {
        // 1. Carga de Lista de empresas
        await cargarIdiomaPreferido(this.cambiarIdioma);
        await this.checkIfWeb3UserOrLoginUser()
  
      }

     cambiarIdioma = (idioma) => {
         const { i18n } = this.props;
         i18n.changeLanguage(idioma); 
         this.forceUpdate(); 
         Cookies.set('idiomaPreferido', idioma, { expires: 365 });// Cambia el idioma usando i18n
       };

      logout = async () => {
        this.setState({bearer: null});
        this.setState({email: null});
        logout();
      }

      async checkIfWeb3UserOrLoginUser() { 
        let params = (new URL(document.location)).searchParams;
        const empresaId = params.get("empresaId");
        this.setState({empresaId});
        localStorage.removeItem('certificado');
        const empresa = JSON.parse(localStorage.getItem('empresa'));
        const mapping = empresa.mapping;
        this.setState({mapping});
        const email = Cookies.get("email");
        this.setState({ email: email });
        let bearerVar = Cookies.get("id");
        this.setState({ bearer: bearerVar });
        const userRol = Cookies.get("rol");
        this.setState({ userRol: userRol });
        let account = await isUserOrWallet(email, bearerVar);
        const bearerToken = await setBearer(email, bearerVar, account);
        Cookies.set('id', bearerToken);
        this.setState({bearer: bearerToken})
      
       
        this.setState({account: account});
      
        
        var empresasList;
        
      
          

          if(typeof bearerVar === 'undefined') {
                  Swal.fire({
                    title: `${i18n.t('connect')}`,
                    icon: 'error',
                    showCancelButton: false,
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: 'Finish'
                  }).then((result) => {
                    if (result.isConfirmed) {
                      
                      window.location.href = `/`;
                      
                    }
                  });
            }else{
                try{
            

                  const empresasList = await apiSecuredRequest(
                    'get',
                    `${properties.apiUrl}/certificat/api/empresas/certificados/${empresaId}`,
                    "",
                    bearerVar
                  );
                
                  // Handle both array and single object cases
                  const data = Array.isArray(empresasList.data)
                    ? empresasList.data
                    : [empresasList.data]; // Wrap it in an array if it's a single object
                
                  // Sort the data
                  const sortedBrands = data.sort((a, b) =>
                    a.certificado.localeCompare(b.certificado)
                  );
                
                  console.log('Sorted Brands:', sortedBrands);
                  
        
                    this.setState({ certificados: sortedBrands })
        
                    } catch (error) {   
                        if (error.response) {
                          this.setState({empresas: null})
                          if (error.response.status === 401) {
                            window.location.href="/"
                          }
                        }
                    }

          }
          


        }
        
  




 constructor(props) {
        super(props)
        this.state = {
          certificados: null,
          mapping: null,
          account: null, 
          email: null, 
          userRol: null,
          bearer: null,
          empresaId: null
        }
      }

render() {

    if (this.state.certificados != null) {
      return (
        <>
         <NavBar mail = {this.state.email} bearer = {this.state.bearer} logout = {this.logout} cambiarIdioma={this.cambiarIdioma}/>

              <table className="cewyBrandsTable">
                <div className="cewyBrandsContainer">
                  <p className="cewyTitleBrands"> {i18n.t('allCertificates')}</p>
                  
                  <tbody>
                  <CertificadoDisplay items={this.state.certificados} mapping={this.state.mapping} />
                  </tbody>
                </div>
              </table>
          <Footer />
        </>
      );

    } else {

      <h1>Loading</h1>
    }
  }
} export default  withTranslation()(ListaCertificados);  
